const CONSTANTS = {
    ON_ADMIN_USERS_IS_LOADING: 'users/ON_ADMIN_USERS_IS_LOADING',
    ON_ADMIN_USERS_DATA: 'users/ON_ADMIN_USERS_DATA',
    ON_ADMIN_USERS_ADD_OR_EDIT_MODAL_IS_LOADING: 'users/ON_ADMIN_USERS_ADD_OR_EDIT_MODAL_IS_LOADING',
    ON_ADMIN_USERS_ADD_OR_EDIT_MODAL_TYPE: 'users/ON_ADMIN_USERS_ADD_OR_EDIT_MODAL_TYPE',
    ON_ADMIN_USERS_ADD_OR_EDIT_MODAL_SELECTED_USER:
        'users/ON_ADMIN_USERS_ADD_OR_EDIT_MODAL_SELECTED_USER',
    ON_ADMIN_USERS_ADD_OR_EDIT_MODAL_IS_SHOWN: 'users/ON_ADMIN_USERS_ADD_OR_EDIT_MODAL_IS_SHOWN'
};

export { CONSTANTS };
